import * as React from "react"

import { AppAntSwitch } from "@components"
import { KPI_TYPE } from "@constants"
import { kpiType } from "@signals"


export default function DIPPriceDiscountSwitch({ ...props }) {
  return <AppAntSwitch
    checked={ kpiType.value === KPI_TYPE.ACTUAL_PRICE }
    onChange={(e) => { kpiType.value = e.target.checked ? KPI_TYPE.ACTUAL_PRICE : KPI_TYPE.DISCOUNT_RRSP } }
    trueText='Price'
    falseText='Discount'
    {...props}
  />
}